import { render, staticRenderFns } from "./Districomoil.vue?vue&type=template&id=4eba19bd&"
import script from "./Districomoil.vue?vue&type=script&lang=js&"
export * from "./Districomoil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports